import { render } from "./WishesPage.vue?vue&type=template&id=61d0f55c&scoped=true"
import script from "./WishesPage.vue?vue&type=script&lang=js"
export * from "./WishesPage.vue?vue&type=script&lang=js"

import "./WishesPage.vue?vue&type=style&index=0&id=61d0f55c&scoped=true&lang=css"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d0f55c"]])

export default __exports__